import React, { useEffect, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import Pagination from '@components/Shared/Pagination/Pagination';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import useGetInventoryCountList from '@hooks/INV/InventoryCount/useGetInventoryCountOpenList';
import Loading from '@components/Shared/Loader/Loading';
import Select from 'react-select';

// const Index = () => {
//     const [search, setSearch] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [dataPerPage] = useState(10);
//   const { t, i18n } = useTranslation();
//   const Navigate = useNavigate();

//   // const { Organizations, loading } = useGetOrganizations();

//   const { InventoryCountOpenList: data, error, loading } = useGetInventoryCountOpenList();

//   const filteredSearch = data?.slice()?.filter(item => {
//     const searchLowerCase = search.toLowerCase();
//     return item.name?.toLowerCase().includes(searchLowerCase);
//   });

//   const indexOfLastData = currentPage * dataPerPage;
//   const indexOfFirstData = indexOfLastData - dataPerPage;
//   const currentData = filteredSearch?.slice(indexOfFirstData, indexOfLastData);
//   //________________________________

//   return (
//     <div>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//              link: ':moduleHome'
//             },
//             {
//               name: 'InventoryCount',
//               link: null
//             }
//           ]}
//           PageName='InventoryCount'
//         />

//         <div className='ms-auto'>
//           <Link to='AddInventoryCount' className='btn me-1 btn-outline-theme'>
//             <i className='fa fa-plus-circle fa-fw me-1'></i>
//             {t('إضافة جرد جديد')}
//           </Link>
//         </div>
//       </div>

//       <Card>
//         {/* <Loader loading={loading} /> */}

//         <CardBody>
//           <div className='row'>
//             <div className='col-7 col-md-6 d-flex justify-content-start'>
//               <div className='input-group mb-2'>
//                 <div className='flex-fill position-relative'>
//                   <div className='input-group'>
//                     <div className='input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0'>
//                       <i className='fa fa-search opacity-5'></i>
//                     </div>
//                     <input
//                       type='text'
//                       autoComplete='off'
//                       className='form-control ps-35px'
//                       onChange={e => setSearch(e.target.value)}
//                       placeholder={t('Search') + ' ...'}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* //  START TABLE   */}
//           <div className='table-responsive'>
//             <table className='table table-hover'>
//               <thead className='table-dark'>
//                 <tr>
//                   <th scope='col'>{t('الأسم')}</th>

//                   <th scope='col'>{t('الفرع')}</th>
//                   <th scope='col'>{t('المخزن')}</th>
//                   <th scope='col'>{t('الذي قام بالجرد')}</th>
//                   <th scope='col'>{t('تاريخ البدء')}</th>
//                   <th scope='col'>{t('تاريخ التجميد')}</th>

//                   <th scope='col'></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentData?.map((item, index: number) => (
//                   <tr key={++index}>
//                     <td className='align-middle'>{i18n.language === 'en' ? item.name : item.name2}</td>
//                     <td className='align-middle'>{i18n.language === 'en' ? item.branchName : item.branchName2}</td>
//                     <td className='align-middle'>
//                       {i18n.language === 'en' ? item.inventoryName : item.inventoryName2}
//                     </td>
//                     <td className='align-middle'>{i18n.language === 'en' ? item.personName : item.personName2}</td>
//                     <td className='align-middle'>{item.startDate?.split('T')[0]}</td>
//                     <td className='align-middle'>{item.freezeDate?.split('T')[0]}</td>

//                     <td className='align-middle text-end'>
//                       <div className='btn-group'>
//                         <button
//                           type='button'
//                           className='btn btn-outline-theme'
//                           // onClick={() => setInventoryId(item.id)} //Departments/:id/Edit
//                         >
//                           <i className='far fa-lg me-2 fa-fw fa-edit'></i>
//                           {t('Button.Edit')}
//                         </button>
//                         <button
//                           type='button'
//                           className='btn btn-outline-theme'
//                           onClick={() => Navigate(`${item.id}/InventoryCountEntries`)}
//                         >
//                           <i className='fas fa-lg me-2 fa-fw fa-boxes'></i>
//                           {t('إدخالات الجرد')}
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <Pagination
//             filteredData={filteredSearch}
//             dataPerPage={dataPerPage}
//             handlePagination={(pageNumber: any) => setCurrentPage(pageNumber)}
//             currentPage={currentPage}
//           />
//         </CardBody>
//       </Card>
//     </div>
//   );
// };


const Index = () => {
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(10);
  const [statusFilter, setStatusFilter] = useState<any>(null);
  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();

  const { InventoryCountOpenList: data, error, loading } = useGetInventoryCountList();

  // console.log(data);
  

  const filteredSearch = data?.slice()?.filter(item => {
    const searchLowerCase = search.toLowerCase();
    const matchesSearch = 
      item.name?.toLowerCase().includes(searchLowerCase) ||
      item.name2?.toLowerCase().includes(searchLowerCase) ||
      item.branchName?.toLowerCase().includes(searchLowerCase) ||
      item.branchName2?.toLowerCase().includes(searchLowerCase) ||
      item.inventoryName?.toLowerCase().includes(searchLowerCase) ||
      item.inventoryName2?.toLowerCase().includes(searchLowerCase) ||
      item.personName?.toLowerCase().includes(searchLowerCase) ||
      item.personName2?.toLowerCase().includes(searchLowerCase);
    
    const matchesStatus = statusFilter ? item.status === statusFilter.value : true;

    return matchesSearch && matchesStatus;
  });

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredSearch?.slice(indexOfFirstData, indexOfLastData);

  // خيارات حالة الجرد
  const statusOptions = [
    { value: 'open', label: t('مفتوح') },
    { value: 'closed', label: t('مغلق') },
    { value: 'frozen', label: t('مجمدة') }
  ];

  const columns = [
    { title: t('الأسم'), key: 'name' },
    { title: t('الفرع'), key: 'branch' },
    { title: t('المخزن'), key: 'inventory' },
    { title: t('الذي قام بالجرد'), key: 'person' },
    { title: t('تاريخ البدء'), key: 'startDate' },
    { title: t('تاريخ التجميد'), key: 'freezeDate' },
    { title: t('الحالة'), key: 'status' },
    { title: '', key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = currentData?.map((item: any) => {
    // تحديد شارة الحالة
    const getStatusBadge = (status: string) => {
      switch (status) {
        case 'open':
          return (
            <span className='badge bg-success p-2'>
              <i className='fas fa-play-circle me-1'></i> {t('مفتوح')}
            </span>
          );
        case 'closed':
          return (
            <span className='badge bg-danger p-2'>
              <i className='fas fa-check-circle me-1'></i> {t('مغلق')}
            </span>
          );
        case 'frozen':
          return (
            <span className='badge bg-warning p-2'>
              <i className='fas fa-snowflake me-1'></i> {t('مجمدة')}
            </span>
          );
        default:
          return (
            <span className='badge bg-secondary p-2'>
              <i className='fas fa-question-circle me-1'></i> {t('غير معروف')}
            </span>
          );
      }
    };

    return {
      name: i18n.language === 'en' ? item.name : item.name2,
      branch: i18n.language === 'en' ? item.branchName : item.branchName2,
      inventory: i18n.language === 'en' ? item.inventoryName : item.inventoryName2,
      person: i18n.language === 'en' ? item.personName : item.personName2,
      startDate: item.startDate?.split('T')[0],
      freezeDate: item.freezeDate?.split('T')[0] || '---',
      status: getStatusBadge(item.status),
      action: (
        <div className='btn-group'>
          <button
            type='button'
            className='btn btn-sm btn-outline-theme me-1'
            onClick={() => Navigate(`${item.id}/EditInventoryCount`)}
          >
            <i className='far fa-lg fa-fw fa-edit me-1'></i>
            {t('Button.Edit')}
          </button>
          <button
            type='button'
            className='btn btn-sm btn-outline-info me-1'
            onClick={() => Navigate(`${item.id}/InventoryCountEntries`)}
          >
            <i className='fas fa-lg fa-fw fa-boxes me-1'></i>
            {t('إدخالات الجرد')}
          </button>
          {/* <button
            type='button'
            className='btn btn-sm btn-outline-secondary'
            onClick={() => Navigate(`${item.id}/InventoryCountReport`)}
          >
            <i className='fas fa-lg fa-fw fa-chart-bar me-1'></i>
            {t('التقرير')}
          </button> */}
        </div>
      )
    };
  });

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: t('Home'),
             link: ':moduleHome'
            },
            {
              name: t('InventoryCount'),
              link: null
            }
          ]}
          PageName={t('InventoryCount')}
        />

        <div className='ms-auto'>
          <Link to='AddInventoryCount' className='btn me-1 btn-theme'>
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('إضافة جرد جديد')}
          </Link>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <div className='row mb-4'>
              <div className='col-lg-6'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text fw-bold'>{t('Search')}</span>
                  <div className='input-group'>
                    <div className='flex-fill position-relative'>
                      <div className='input-group border-0 '>
                        <div className='input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0'>
                          <i className='fa fa-search opacity-5 text-theme'></i>
                        </div>
                        <input
                          type='text'
                          autoComplete='off'
                          className='form-control ps-35px'
                          value={search}
                          onChange={e => {
                            setSearch(e.target.value);
                            setCurrentPage(1); // العودة للصفحة الأولى عند البحث
                          }}
                          placeholder={t('Search') + ' ...'}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-lg-6'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text fw-bold'>{t('الحالة')}</span>
                  <Select
                    classNamePrefix='react-select'
                    className='w-100'
                    isSearchable={true}
                    isClearable
                    options={statusOptions}
                    onChange={option => {
                      setStatusFilter(option);
                      setCurrentPage(1); // العودة للصفحة الأولى عند التصفية
                    }}
                    placeholder={t('Choose')}
                  />
                </div>
              </div>
            </div>

            {/* الجدول المحسن */}
            <div className='table-responsive rounded-2  '>
              <table className='table table-hover mb-0'>
                <thead className='bg-theme bg-opacity-30 text-nowrap'>
                  <tr>
                    {columns.map((column, index) => (
                      <th 
                        key={index} 
                        className={`align-middle ${column.className || ''}`}
                      >
                        {column.title}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableData && tableData.length > 0 ? (
                    tableData.map((row: any, index: number) => (
                      <tr key={index}>
                        {columns.map((column, colIndex) => (
                          <td key={colIndex} className='align-middle'>
                            {row[column.key]}
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={columns.length} className='text-center py-4 text-muted'>
                        <i className='fas fa-inbox fa-2x mb-2'></i>
                        <div>{t('لا توجد بيانات')}</div>
                        <small className='text-muted'>
                          {search || statusFilter 
                            ? t('جرب تغيير مصطلحات البحث أو إزالة الفلتر') 
                            : t('انقر على "إضافة جرد جديد" لبدء الإضافة')}
                        </small>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* الترقيم */}
            {filteredSearch && filteredSearch.length > 0 && (
              <div className='mt-3'>
                <Pagination
                  filteredData={filteredSearch}
                  dataPerPage={dataPerPage}
                  handlePagination={(pageNumber: any) => setCurrentPage(pageNumber)}
                  currentPage={currentPage}
                />
              </div>
            )}

            {/* إحصائيات */}
            {filteredSearch && filteredSearch.length > 0 && (
              <div className='row mt-2'>
                <div className='col-12 text-center'>
                  <small className='text-muted'>
                    {t('عرض {from} إلى {to} من {total} عنصر', {
                      from: indexOfFirstData + 1,
                      to: Math.min(indexOfLastData, filteredSearch.length),
                      total: filteredSearch.length
                    })}
                  </small>
                </div>
              </div>
            )}
          </CardBody>
        </Loading>
      </Card>
    </>
  );
};

export default Index;
